export default __webpack_public_path__ + "static/media/8-Pre-Listing-redflags.78e2fc99.png";